import { FC, useMemo } from 'react';
import { useEffect, useState } from 'react';
import { useDP3Store } from '@elem/compPage/DP3/DP3Provider';
import EfImg from 'elem/ui/ef-img';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper';
import { IPageStatus } from '@elem/compPage/DP3/components/IPageStatus';
import css from './index.module.scss';
import { useLang } from '@/i18n';

const TheComp: FC = () => {
    const { t } = useLang('dp3');
    const { pageStatus } = useDP3Store();
    const [isPC, setIsPC] = useState(true);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsPC(window.innerWidth > 1024);
        }
    }, []);

    const isPageStatusA = useMemo(() => pageStatus === IPageStatus.statusA, [pageStatus]);

    return (
        <div
            id="dp3-teaser-E"
            className={`${css.thecomp} GtmModuleData-section`}
            data-section-id={'dp3-C'}
            data-section-title={'For Those Focused on Electricity Cost Savings Through Self-Consumption'}
        >
            {isPageStatusA && <div className="dp3-spec"></div>}
            <div className="info">
                <p className="title">For Those Focused on Electricity Cost Savings Through Self-Consumption</p>
                <p className="desc">
                    Easily start an energy-saving lifestyle without the need for electrical work. With the EcoFlow DELTA Pro 3, you can build a home energy
                    storage system without connecting to the grid, lowering installation costs. By storing solar power in the DELTA Pro 3 during the day and
                    using that stored energy to power your home at night, you can save approximately 22% of energy per day with just one unit. When combined
                    with an extra battery, your daily energy savings can increase to 44%. With two extra batteries, expect up to 66% in energy savings.
                </p>
            </div>
            {isPC ? (
                <div className="box">
                    <EfImg pc="https://websiteoss.ecoflow.com/upload/image/1727345664310/pc.jpg" />
                    <p className="tip">
                        *Assuming the product is directly connected to solar panels, fully charged during the day with solar power, and used at night.
                    </p>
                </div>
            ) : (
                <div className="box">
                    <Swiper
                        className="swiper-box"
                        modules={[Pagination, Autoplay]}
                        spaceBetween={0}
                        slidesPerView={'auto'}
                        initialSlide={0}
                        loop={true}
                        pagination={{ clickable: true }}
                        // autoplay={{
                        //     delay: 4250,
                        //     disableOnInteraction: false,
                        // }}
                    >
                        <SwiperSlide className={`swiper-item`}>
                            {/* <EfImg pc="https://websiteoss.ecoflow.com/upload/image/1726716762859/1-1-tuya.jpg" /> */}
                            <EfImg pc="https://websiteoss.ecoflow.com/upload/image/1727578542523/au-sc3.jpg" />
                        </SwiperSlide>
                        <SwiperSlide className={`swiper-item`}>
                            <EfImg pc="https://websiteoss.ecoflow.com/upload/image/1727345664082/h5.jpg" />
                        </SwiperSlide>
                    </Swiper>
                    {isPageStatusA && (
                        <p className="tip">
                            *Assuming the product is directly connected to solar panels, fully charged during the day with solar power, and used at night.
                        </p>
                    )}
                </div>
            )}
        </div>
    );
};

export default TheComp;
